import { observable, action, computed } from "mobx"
import request from "app/vendor/request"
import config from "app/config"
import { getRandomColor, splitStrNumber } from "app/vendor/util"
// import { message } from "antd"

const SINGLE_RELATION_NAME = [
  "男方",
  "男方父亲",
  "男方母亲",
  "女方",
  "女方母亲",
  "女方父亲",
]
export default class {
  @observable familyId = "" // 直接写 id 可能会好些
  @observable tableData = []
  @observable sampleData = {}
  @observable historyTableData = []
  @observable selectedRowKeys = []
  @observable totalPrimers = []
  @observable totalGenes = []
  @observable originGenes = []
  @observable relations = []
  @observable familyInfo = {}
  @observable appInfo = null
  @observable editHistoryList = []
  @observable samplesData = []
  @observable edited = false
  @observable traninfos = [{
    type: 'null',
    name: '',
    breakpoint: '',
    chromosome: '',
    startPosition: '',
    endPosition: '',
    chromosome2: ''
  }]
  singleRelations = []

  @action loadFamilyInfo = () => {
    return request
      .get(`${config.backend}/array-pgt/family/${this.familyId}`)
      .checkToken()
      .commonDispose()
      .then((res) => {
        this.familyInfo = res
      })
  }

  @action setFamilyId = (id) => {
    this.familyId = id
  }

  @action setEdited = () => {
    this.edited = true
  }

  @action initTableData = () => {
    return request
      .get(`${config.backend}/array-pgt/family/${this.familyId}/datas?refresh=true`)
      .checkToken()
      .commonDispose()
      .then((result) => {
        this.processResult(result)
        result.dataSamples && result.dataSamples.forEach(this.processData)
        if (result.traninfos) {
          this.disposeReturnTraninfos(result)
        } else {
          result.traninfos = this.traninfos
        }
        this.sampleData = result
      })
  }

  @action disposeReturnTraninfos = (result) => {
    this.traninfos = result.traninfos.map(tran => {
      if (tran.type === 'null') {
        return {
          type: 'null',
          name: '',
          breakpoint: '',
          chromosome: '',
          startPosition: '',
          endPosition: '',
          chromosome2: ''
        }
      }
      return tran
    })
  }

  processResult(result) {
    result.chipType = result.chipType
    result.genes = (result.genes && result.genes.length) ? result.genes : ['null']
    result.range = result.range
  }

  processData(sample) {
    sample.hasName = sample.sampleName
    sample.sampleName = sample.sampleName // 手动生成字段
    sample.relationName = sample.relationName
    sample.pathogen = sample.pathogen
    sample.chipType = sample.chipType
    sample.name = sample.name
    sample.remark = sample.remark
    sample.hospitalSampleName = sample.hospitalSampleName
    sample.marked = false
  }

  @action handleTraninfoObj = (traninfo, type) => {
    switch (type) {
      case 'trans':
        const tran_arr = this.traninfos.filter(tran => tran.type === 'trans')
        tran_arr.forEach((tran, idx) => tran.name = 'tran' + (idx + 1))
        break
      case 'inv':
        const inv_arr = this.traninfos.filter(tran => tran.type === 'inv')
        inv_arr.forEach((inv, idx) => inv.name = 'inv' + (idx + 1))
        break
      default:
    }
  }

  @action loadPrimers = () => {
    return request
      .get(`${config.backend}/array-pgt/primers`)
      .checkToken()
      .commonDispose()
      .then((res) => {
        this.totalPrimers = res
      })
  }

  @action loadGenes = () => {
    return request
      .get(`${config.backend}/array-pgt/genes`)
      .checkToken()
      .commonDispose()
      .then((res) => {
        this.originGenes = res
      })
  }

  @action setTotalGenes = (filterGenes) => {
    this.totalGenes = filterGenes
  }

  @action loadRelations = () => {
    return request
      .get(`${config.backend}/pgd/relations`)
      .checkToken()
      .commonDispose()
      .then((result) => {
        this.setRelationColor(result)
        this.relations = result
        this.singleRelations = result.filter(
          (relation) => SINGLE_RELATION_NAME.indexOf(relation.name) > -1
        )
        this.completeRelations() // 加颜色
        this.updateRelationStatus()
      })
  }

  @action setRelationColor = (arr) => {
    arr.forEach((relation) => (relation.color = getRandomColor()))
  }

  @action onGenesSelect = (genes) => {
    if (this.sampleData.dataSamples) {
      this.sampleData.genes = this.calculateGenes(genes)
      this.edited = true
    }
  }

  @action calculateGenes = (genes) => {
    if (genes.length) {
      if (genes.includes('null')) {
        return genes.filter(gene => gene !== 'null')
      } else {
        return genes
      }
    } else {
      return ['null']
    }
  }

  @action onTraninfoChange = (sample, field, value, that) => {
    sample[field] = value
    this.edited = true
    that && that.forceUpdate()
  }

  @action onRangeChange = (range) => {
    if (this.sampleData.dataSamples) {
      this.sampleData.range = range
      this.edited = true
    }
  }

  @action onSampleNameChange = (value, sample) => {
    sample.sampleName = value
    this.edited = true
  }

  @action onInputChange = (value, sample, field) => {
    sample[field] = value
    this.sampleData.dataSamples.forEach((item) => {
      if (sample.relationId && item.relationId === sample.relationId) {
        item[field] = value
      }
    })
    this.edited = true
  }
    @action onInputChangeRemark = (value, sample, field) => {
      sample[field] = value
      this.edited = true
    }

  @action onGeneSelect = (gene, sample) => {
    sample.genes.push(gene)
    const mutations = sample.genes.slice()
    this.sampleData.dataSamples.forEach((item) => (item.genes = sample.genes))
    this.loadMutations(mutations)
  }

  @action onGeneDeselect = (gene, sample) => {
    const primerIndex = sample.genes.findIndex((item) => item === gene)
    sample.genes.splice(primerIndex, 1)
    const mutations = sample.genes.slice()
    this.sampleData.dataSamples.forEach((item) => (item.genes = sample.genes))
    if (mutations.length > 0) {
      this.loadMutations(mutations)
    }
  }

  @action onMutationsSelect = (mutation, sample) => {
    sample.mutations.push(mutation)
    this.sampleData.dataSamples.forEach((item) => {
      if (item.relationId === sample.relationId) {
        item.mutations = sample.mutations
      }
    })
    this.edited = true
  }

  @action onMutationsDeselect = (mutation, sample) => {
    const mutationIndex = sample.mutations.findIndex(
      (item) => item === mutation
    )
    sample.mutations.splice(mutationIndex, 1)

    this.sampleData.dataSamples.forEach((item) => {
      if (item.relationId === sample.relationId) {
        item.mutations = sample.mutations
      }
    })
  }

  /* 因为 select 组件中初始值为数组时必须为 group of ids，
   * 而每一个 primer 又没有唯一的 id，因此选择直接拿它本身做显示值
   * 和 key
   */
  @action onPrimerSelect = (primer, sample) => {
    sample.primers.push(primer)
    this.sampleData.dataSamples.forEach((item) => (item.primers = sample.primers))
    this.usePrimersGetGenes(JSON.stringify(sample.primers))
    this.edited = true

  }

  @action onPrimerDeselect = (primer, sample) => {
    const primerIndex = sample.primers.findIndex((item) => item === primer)
    sample.primers.splice(primerIndex, 1)
    this.sampleData.dataSamples.forEach((item) => (item.primers = sample.primers))
    this.usePrimersGetGenes(JSON.stringify(sample.primers))
    this.edited = true
  }

  @action usePrimersGetGenes = (params, sample) => {
    return request
      .get(`${config.backend}/array-pgt/primers/genes?body=${params}`)
      .checkToken()
      .commonDispose()
      .then((res) => {
        this.sampleData.dataSamples.forEach((item) => (item.genes = res))
      })
  }

  @action onRelationChange = (relationId, sample) => {
    const relation = this.relations.find(
      (relation) => relation.id === relationId
    )
    sample.relationId = relation.id
    sample.relationName = relation.name
    sample.color = relation.color

    this.disposeName(sample)
    this.disposePathogen(sample, relation)
    // this.disposeMutation(sample, relation)

    if (!this.singleRelations.find((relation) => relation.id === relationId)) {
      this.addNewRelation(relation)
    }

    this.updateRelationStatus()
    this.edited = true
  }

  @action disposePathogen = (sample) => {
    let pathogen
    const sameRelationList = this.sampleData.dataSamples.filter((item) => {
      // 关系相同，且不是同一条数据的。 tip:如果是同一条数据，会出现pathogen字段不变的bug
      return item.relationId === sample.relationId && item.id !== sample.id
    })

    sameRelationList.some((item) => {
      if (item.pathogen) {
        pathogen = item.pathogen
        return true
      }
      return false
    })

    if (pathogen) {
      sample.pathogen = pathogen
      return
    }

    sample.pathogen = /^(子代)/.test(sample.relationName) ? "p0,m0" : ""
  }

  @action disposeName = (sample) => {
    let name
    const sameRelationList = this.sampleData.dataSamples.filter((item) => {
      return item.relationId === sample.relationId && item.id !== sample.id
    })
    sameRelationList.some((item) => {
      if (item.name) {
        name = item.name
        return true
      }
      return false
    })
    if (name) {
      sample.name = name
      return
    }
  }

  // @action disposeMutation = (sample) => {
  //   let mutation
  //   const sameRelationList = this.tableData.filter((item) => {
  //     return item.relationId === sample.relationId && item.id !== sample.id
  //   })
  //   sameRelationList.some((item) => {
  //     if (item.mutations) {
  //       mutation = item.mutations
  //       return true
  //     }
  //     return false
  //   })
  //   if (mutation) {
  //     sample.mutations = mutation
  //     return
  //   }
  //   sample.mutations = []
  // }

  @action onPathogenChange = (key, sample) => {
    this.sampleData.dataSamples.forEach((item) => {
      if (item.relationId === sample.relationId) {
        item.pathogen = key
      }
    })
    this.edited = true
  }
  @action onChipTypeAloneChange = (key, sample) => {
    this.sampleData.dataSamples.forEach((item) => {
      if (item.relationId === sample.relationId) {
        item.chipType = key
      }
    })
    this.edited = true
  }
  @action onChipTypeChange = (chipType) => {
    if (this.sampleData.dataSamples) {
      this.sampleData.chipType = chipType
    }
    // 芯片类型-全选
    this.sampleData.dataSamples.forEach((item) => {
        item.chipType = chipType
    })
    this.edited = true
  }

  /**
   * 遍历列表数据选中的relationId，如果出现次数多余两次，增加marked字段为true。
   * 视图里通过判断marked字段，渲染颜色小球
   */
  @action updateRelationStatus() {
    const tempMap = {}

    if (this.sampleData.dataSamples) {
      this.sampleData.dataSamples.forEach(sample => {
        tempMap[sample.relationId] = tempMap[sample.relationId] ? tempMap[sample.relationId] + 1 : 1
      })
      this.sampleData.dataSamples.forEach(sample => {
        sample.marked = tempMap[sample.relationId] > 1
      })
    }
  }

  @action updateTableData = () => {
    this.sampleData.dataSamples.forEach((sample) => {
      sample.hasName = sample.sampleName
      sample.hasRemark = sample.remark
    })
  }

  /**
   * 没选关系不处理
   * 选了关系
   * 1. 选了关系 是基本关系里的 就给他加关系的颜色
   * 2. 选了关系 不是基本关系里的 给他加新颜色
   *   1. 如果
   */
  @action completeRelations = () => {
    this.sampleData.dataSamples && this.sampleData.dataSamples.forEach((sample) => {
      const relation = this.relations.find(
        (relation) => relation.id === sample.relationId
      )
      if (relation) {
        // 选了关系 是基本关系里的 就给他加关系的颜色
        sample.color = relation.color
      } else {
        if (sample.relationId) {
          // 选了关系 不是基本关系里的 给他加新颜色
          const newColor = getRandomColor()
          sample.color = newColor
          const position = this.getCompletePosition(sample.relationName)
          const newRelation = {
            id: sample.relationId,
            name: sample.relationName,
            color: newColor,
          }
          this.relations.splice(position, 0, newRelation)

          const bundle = splitStrNumber(newRelation.name)
          const newName = bundle.string + (bundle.number + 1)
          if (
            !this.sampleData.dataSamples.find((sample) => sample.relationName === newName)
          ) {
            this.addNewRelation(newRelation) // newRelation 被插入后，会被 observable 化，此时 newRelation 不再持有数组堆内存
          }
        }
      }
    })
  }

  /*
   * 我们需要根据一定规律插入到对应的位置
   * 只需要正向遍历即可
   */
  getCompletePosition = (relationName) => {
    const bundle = splitStrNumber(relationName)

    for (let i = this.relations.length - 1; i >= 0; i--) {
      const currentBundle = splitStrNumber(this.relations[i].name)
      if (
        bundle.string === currentBundle.string &&
        bundle.number > currentBundle.number
      ) {
        return i + 1
      }
    }
  }

  @action addNewRelation = (relation) => {
    const aimIndex =
      this.relations.findIndex((item) => item.name === relation.name) + 1

    const bundle = splitStrNumber(relation.name)
    const newName = bundle.string + (bundle.number + 1)

    if (!this.relations.find((relation) => relation.name === newName)) {
      this.relations.splice(aimIndex, 0, {
        gender: relation.gender,
        id: relation.id + aimIndex,
        name: newName,
        color: getRandomColor(),
      })
    }
  }

  @action getHistoryTableData = () => {
    return request
      .get(`${config.backend}/array-pgt/family/${this.familyId}/tasks`)
      .checkToken()
      .commonDispose()
      .then((res) => {
        this.historyTableData = res
      })
  }

  @action getTaskDatas = (taskId) => {
    return request
      .get(
        `${config.backend}/array-pgt/family/${this.familyId}/tasks/${taskId}/datas`
      )
      .checkToken()
      .commonDispose()
  }

  @action setTaskDatas = (id, data) => {
    const rowIndexInCard = this.historyTableData.findIndex(
      (item) => item.id === id
    )
    this.historyTableData[rowIndexInCard].datas = data.dataSamples
  }

  @action clearTaskDetail = () => {
    this.taskDetail = []
  }

  /*
   * 按照 relationId 对 tableData 进行分组
   */
  @computed get composedData() {
    this.sampleData.dataSamples.forEach((data) => data.relationName)

    const result = {}
    this.selectedData.forEach((sample) => {
      if (result[sample.relationId]) {
        result[sample.relationId].push(sample)
      } else {
        result[sample.relationId] = [sample]
      }
    })

    return result
  }

  @computed get selectedData() {
    return this.sampleData.dataSamples.filter((item) =>
      this.selectedRowKeys.includes(item.id)
    )
  }

  @computed get runReady() {
    const { genes } = this.sampleData
    const someIsNull = this.traninfos.some(traninfo => traninfo.type === 'null')
    if (genes && genes.toString() === 'null' && someIsNull) {
      return (
        this.selectedRowKeys.length > 0
      )
    } else {
      return (
        this.selectedRowKeys.length > 0 &&
        !this.selectedData.some(
          (sample) =>
            !sample.relationName || !sample.pathogen
        )
      )
    }
  }

  @computed get saveReady() {
    return this.edited
  }

  @action deleteData = (sampleId) => {
    const index = this.sampleData.dataSamples.findIndex((data) => data.id === sampleId)
    this.sampleData.dataSamples.splice(index, 1)
  }

  @action getAppInfo = () => {
    return request
      .get(`${config.backend}/array-pgt/apps/${this.familyInfo.appId}`)
      .checkToken()
      .commonDispose()
      .then((res) => (this.appInfo = res))
  }

  @action clearAppInfo = () => {
    this.appInfo = null
  }

  @action disposeTraninfos = () => {
    this.traninfos = this.traninfos.map(traninfo => {
      if (traninfo.type === 'null') {
        return { type: traninfo.type }
      }
      return traninfo
    })
    this.sampleData.traninfos = this.traninfos
  }

  @action saveDatas = () => {
    this.disposeTraninfos()
    return request
      .put(`${config.backend}/array-pgt/family/${this.familyId}/datas`)
      .send(this.sampleData)
      .checkToken()
      .commonDispose()
  }

  @action deleteSample = (sampleId) => {
    return request
      .delete(`${config.backend}/array-pgt/family/${this.familyId}/datas/samples/${sampleId}`)
      .checkToken()
      .commonDispose()
  }

  @action updateSample = (sampleName, remark, sampleId) => {
    return request
      .put(`${config.backend}/array-pgt/datas/${sampleId}`)
      .send({ sampleName, remark })
      .checkToken()
      .commonDispose()
  }

  @action loadEditHistory = (dataId) => {
    return request
      .get(`${config.backend}/array-pgt/datas/${dataId}/history`)
      .checkToken()
      .commonDispose()
      .then((res) => (this.editHistoryList = res))
  }

  @action clearEditHistory = () => {
    this.editHistoryList = []
  }

  @action runTask = () => {
    return request
      .post(`${config.backend}/array-pgt/family/${this.familyId}/tasks?appId=${this.familyInfo.appId}`)
      .send(this.selectedRowKeys.slice())
      .checkToken()
      .commonDispose()
  }

  @action clearState = () => { }

  @action updateRemarks = (record, remark) => {
    return request
      .put(`${config.backend}/array-pgt/family/${this.familyId}/tasks/${record.id}`)
      .send({ remark })
      .checkToken()
      .commonDispose()
  }

  /**
   * 由后端提供支持
   */
  @action parseCSV = (csvText) => {
    return request
      .put(`${config.backend}/array-pgt/family/${this.familyId}/datas/csv`)
      .checkToken()
      .send({ context: csvText })
      .commonDispose()
      .then((result) => {
        result.forEach(this.processData)
        this.sampleData.dataSamples = result
        this.completeRelations() // 加颜色
        this.updateRelationStatus()
      })
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/arrayPgt/dataManageDetail.js